module.exports = __webpack_public_path__ + "img/cover_productys.d13111fa.png";